
export default {
  name: 'ProductVariants',
  props: {
    variants: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    updateVariant(event, key) {
      this.$emit('input', { ...this.value, [key]: event.target.value })
    }
  }
}
